/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';
import { Button as TOButton } from 'timeone-components';

export const Button = styled(TOButton)`
  margin-left: auto;
`;
